import { Component, Input ,OnChanges,SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../../components/sample/model/question-base';

@Component({
  selector: 'textarea-question',
  template:`<div [formGroup]="form">
  <kendo-formfield>
          <kendo-floatinglabel  [text]="question.label">
          <kendo-textarea
          [id]="question.key"
          [formControlName]="question.key"
            resizable="vertical"
            [disabled]=" question.value.length && question.disabled"
          ></kendo-textarea>
          </kendo-floatinglabel>
          <kendo-formhint *ngIf="question.hint" align="start">
           {{question.hint}}
          </kendo-formhint>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.required">Error: {{errorRequired.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.maxlength">Error: {{errorMax.value}}</kendo-formerror>
       <kendo-formerror *ngIf="form.controls[question.key].errors?.minlength">Error: {{errorMin.value}}</kendo-formerror>
        </kendo-formfield>
</div>`
})
export class TextareaFormQuestionComponent  implements OnChanges {
  @Input() question!: QuestionBase<string>;
  @Input() form!: FormGroup;

  errorRequired: { key: string; value: string; };
  errorMax: { key: string; value: string; };
  errorMin: { key: string; value: string; };

  ngOnChanges(changes: SimpleChanges) {
    if(changes.question.firstChange){ 
      this.errorRequired = changes.question.currentValue.errors.find( ({ key }) => key === 'required' )
      this.errorMax = changes.question.currentValue.errors.find( ({ key }) => key === 'maxLength' )
      this.errorMin = changes.question.currentValue.errors.find( ({ key }) => key === 'minLength' )
    }
  }
}